module.exports = __webpack_public_path__ + "media/icons/link-75b49654.svg";